import { Paginate } from '@/types/paginate';
import { Subscription } from '@/types/subscription';

import AppApi from './app-api';

class SubscriptionApi {
  constructor(private api: AppApi) {}

  async getSubscription() {
    const res = await this.api.INSTANCE.get(`/subscriptions/current`);
    if (res.status === 404) return null;
    return res.data as Subscription;
  }

  async getReservedSubscription() {
    const res = await this.api.INSTANCE.get(`/subscriptions/reserved`);
    return res.data as Subscription;
  }

  async getSubscriptionList({ page = 1, limit = 10 }: { page: number; limit: number }) {
    const searchParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
    }).toString();
    const res = await this.api.INSTANCE.get(`/subscriptions/list?${searchParams}`);

    return res.data as Paginate<Subscription>;
  }

  async cancelSubscription() {
    const res = await this.api.INSTANCE.post(`/subscriptions/cancel`);

    return res.data as string;
  }
}

export default SubscriptionApi;
